import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChart4"><Path d="M16 21.001V3.00098H21V21.001H16Z" fill="currentColor"/><Path d="M9.5 8.50098V21.001H14.5V8.50098H9.5Z" fill="currentColor"/><Path d="M3 14.001V21.001H8V14.001H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChart4;
